module.exports = __webpack_public_path__ + "static/media/19CompraPaquetes-19.e22fb030.png";